@file:Suppress("ClassName")

package api

sealed class KioskLayoutType(val mask: Int, val key: String) {

    data object STANDARD : KioskLayoutType(2, "STANDARD")
    data object NO_BRANDING : KioskLayoutType(4, "NO_BRANDING")

    infix fun match(mask: Int): Boolean = this.mask and mask > 0

    companion object {
        val all by lazy {
            listOf(
                STANDARD,
                NO_BRANDING
            )
        }

        operator fun get(type: Int): KioskLayoutType {
            return all.firstOrNull { it match type } ?: STANDARD
        }

        operator fun get(key: String): KioskLayoutType {
            return all.firstOrNull { it.key == key.uppercase() } ?: STANDARD
        }
    }
}
